module.exports = __webpack_public_path__ + "static/media/chevron-square-left.2bf10db7.svg";